export const COLOR_BG_PRIMARY = 'rgb(32 32 32)';
export const COLOR_BG_SECONDARY = 'rgb(24 24 24)';
export const COLOR_BORDER_PRIMARY = 'rgb(64 64 64)';
export const COLOR_TEXT_PRIMARY = 'rgb(208 208 208)';
export const SPACING_SMALL = '0.25em';
export const FONT_WEIGHT_BOLD = '500';
//# sourceMappingURL=theme.js.map